import AppRoutePath from "./AppRoutePath";
import Dashboard from "../pages/Dashboard";
import Employee from "../pages/users/employee/list_employee/index";
import AddEmployee from "../pages/users/AddEmployee";
import Jabatan from "../pages/jabatan/Jabatan";
import Outlet from "../pages/outlet/Outlet";
import ListRole from "../pages/role_access/ListRole";
import AddRole from "../pages/role_access/AddRole";
import UpdateRole from "../pages/role_access/UpdateRole";
import ViewEmployee from "../pages/users/employee/detail_employee/index";
import DailyTask from "../pages/task/DailyTask";
import ReportDailyTask from "../pages/task/ReportDailyTask";
import ListUser from "../pages/users/list_users/index";
import Campaign from "../pages/campaign/list_campaign";
import AddCampaign from "../pages/campaign/add_campaign/add_loan";
import AddCampaignDefault from "../pages/campaign/add_campaign_default/add_loan";
import CampaignDefault from "../pages/campaign/list_campaign_default";
import Customers from "../pages/customer/list_customer";
import DetailCustomer from "../pages/customer/detail_customer";
import PawnTransaction from "../pages/finance/transaction_history/pawn_transaction";
import CapitalCashTransaction from "../pages/finance/transaction_history/capital_cash_transaction";
import MidTransApproval from "../pages/finance/midtrans_approval";
import RefundReport from "../pages/finance/refund/list_refund";
import FailedRedeem from "../pages/finance/report/failed_redeem";
import CapitalCashOutlet from "../pages/settings/capital_cash_outlet";
import TopupDepositPage from "../pages/finance/topup_deposit";
import LoanNonCash from "../pages/pawn_transaction/loan_noncash";
import PaymentNonCash from "../pages/pawn_transaction/payment_noncash";
import AddCampaignDefaultExtension from "../pages/campaign/add_campaign_default/add_extension";
import AddCampaignExtension from "../pages/campaign/add_campaign/add_extension";
import ListShelf from "../pages/shelf/ListShelf";
import ListStorage from "../pages/storage/ListStorage";
import ListProductCategory from "../pages/product/product_category/ListProductCategory";
import ListLabel from "../pages/label/ListLabel";
import ListPointWithdrawal from "../pages/pencairan_poin/ListPointWithdrawal";
import ListOutletDebitCard from "../pages/outlet_debit_card/ListOutletDebitCard";
import SbgPrivate from "../pages/sbg/SbgPrivate";
import PawnTransactionReport from "../pages/finance/report/pawn_transaction";
import EditCampaign from "../pages/campaign/edit_campaign/edit_loan";
import EditCampaignDefault from "../pages/campaign/edit_campaign/edit_loan_default";
import EditCampaignDefaultExtension from "../pages/campaign/edit_campaign/edit_extension_default";
import EditCampaignExtension from "../pages/campaign/edit_campaign/edit_extension";
import GadaiReportDetail from "../pages/finance/report/pawn_transaction/components/GadaiReportDetail";
import ProcessLoanPage from "../pages/pawn_transaction/loan_noncash/components/ProcessLoanPage";
import ListProducts from "../pages/product/list_product";
import UploadProduct from "../pages/product/upload_product";
import RefundRequest from "../pages/finance/refund/request_refund";
import RefundExpired from "../pages/finance/refund/refund_expired";
import AreaList from "../pages/area_jemput_global/area_list/index";
import AddArea from "../pages/area_jemput_global/add_area/index";
import JemputGadai from "../pages/jemput_gadai/jemputgadai/index";
import GadaiTerjadwal from "../pages/jemput_gadai/jemput_terjadwal/index";
import PermohonanPengembalian from "../pages/pengembalian_barang/permohonan/index";
import PengembalianTerjadwal from "../pages/pengembalian_barang/terjadwal/index";
import HistoryPengembalian from "../pages/pengembalian_barang/history/index";
import AppraiserList from "../pages/appraiser/appraiser";
import OutletAppraiserList from "../pages/appraiser/outlet_appraiser";
import AddOutletAppraiser from "../pages/appraiser/add_outlet_appraiser";
import ExclusiveList from "../pages/exclusive/list_exclusive";
import ExclusiveAdd from "../pages/exclusive/create_exclusive";
import CompanySetting from "../pages/settings/company_setting";
import CommissionDisbursement from "../pages/finance/commission_disbursement/list_agent_referral";
import MembershipSetting from "../pages/settings/membership_setting";
import BankList from "../pages/settings/bank";
import NotificationSettingList from "../pages/settings/notification_setting/list_notification";
import AddNotification from "../pages/settings/notification_setting/add_notification";
import AddCampaignInstallmentReguler from "../pages/campaign/installment/add_campaign/default";
import AddCampaignInstallmentOffer from "../pages/campaign/installment/add_campaign/offer";
import Redeem from "../pages/pawn_transaction/redeem";
import AddCampaignInstallmentRegulerV2 from "../pages/campaign/installment/add_campaign_v2/default";
import AddCampaignInstallmentOfferV2 from "../pages/campaign/installment/add_campaign_v2/offer";
import Voucher from "../pages/finance/voucher";

const AppRouteData = [
  { path: AppRoutePath.DASHBOARD, component: Dashboard },
  { path: AppRoutePath.USERS_EMPLOYEE, component: Employee },
  { path: AppRoutePath.USERS_ADD_EMPLOYEE, component: AddEmployee },
  { path: AppRoutePath.USERS_EDIT_EMPLOYEE, component: AddEmployee },
  { path: AppRoutePath.USERS_VIEW_EMPLOYEE, component: ViewEmployee },
  { path: AppRoutePath.USERS_JABATAN, component: Jabatan },
  { path: AppRoutePath.USERS_OUTLET, component: Outlet },
  { path: AppRoutePath.USERS_LIST_USER, component: ListUser },
  { path: AppRoutePath.STORAGE, component: ListStorage },
  { path: AppRoutePath.SHELF, component: ListShelf },
  { path: AppRoutePath.LABEL, component: ListLabel },
  { path: AppRoutePath.POINT_WITHDRAWAL, component: ListPointWithdrawal },
  { path: AppRoutePath.OUTLET_DEBIT_CARD, component: ListOutletDebitCard },
  { path: AppRoutePath.PRODUCT_CATEGORY, component: ListProductCategory },
  { path: AppRoutePath.ROLE, component: ListRole },
  { path: AppRoutePath.ROLE_ADD_ROLE, component: AddRole },
  { path: AppRoutePath.ROLE_EDIT_ROLE, component: UpdateRole },
  { path: AppRoutePath.TASK_DAILY_TASK, component: DailyTask },
  { path: AppRoutePath.TASK_REPORT_DAILY_TASK, component: ReportDailyTask },
  { path: AppRoutePath.PAWN_TRANSACTION, component: PawnTransaction },
  { path: AppRoutePath.CAPITAL_CASH_TRANSACTION, component: CapitalCashTransaction, },
  { path: AppRoutePath.MIDTRANS_APPROVAL, component: MidTransApproval },
  { path: AppRoutePath.REFUND_REPORT, component: RefundReport },
  { path: AppRoutePath.REFUND_REQUEST, component: RefundRequest },
  { path: AppRoutePath.REFUND_EXPIRED, component: RefundExpired },
  { path: AppRoutePath.CAMPAIGN_LOAN_ADD, component: AddCampaign },
  { path: AppRoutePath.CAMPAIGN_LOAN_EDIT, component: EditCampaign },
  { path: AppRoutePath.CAMPAIGN, component: Campaign },
  { path: AppRoutePath.CAMPAIGN_LOAN_ADD_DEFAULT, component: AddCampaignDefault },
  { path: AppRoutePath.CAMPAIGN_LOAN_EDIT_DEFAULT, component: EditCampaignDefault },
  { path: AppRoutePath.CAMPAIGN_DEFAULT, component: CampaignDefault },
  { path: AppRoutePath.CUSTOMER, component: Customers },
  { path: AppRoutePath.CUSTOMER_DETAIL, component: DetailCustomer },
  { path: AppRoutePath.TOPUP_DEPOSIT, component: TopupDepositPage },
  { path: AppRoutePath.FAILED_REDEEM_REPORT, component: FailedRedeem },
  { path: AppRoutePath.CAPITAL_CASH_OUTLET, component: CapitalCashOutlet },
  { path: AppRoutePath.LOAN_NONCASH, component: LoanNonCash },
  { path: AppRoutePath.PAYMENT_NONCASH, component: PaymentNonCash },
  { path: AppRoutePath.CAMPAIGN_EXTENSION_ADD_DEFAULT, component: AddCampaignDefaultExtension },
  { path: AppRoutePath.CAMPAIGN_EXTENSION_EDIT_DEFAULT, component: EditCampaignDefaultExtension },
  { path: AppRoutePath.CAMPAIGN_EXTENSION_ADD, component: AddCampaignExtension, },
  { path: AppRoutePath.CAMPAIGN_EXTENSION_EDIT, component: EditCampaignExtension, },
  { path: AppRoutePath.SBG_PRIVATE, component: SbgPrivate },
  { path: AppRoutePath.PAWN_TRANSACTION_REPORT, component: PawnTransactionReport },
  { path: AppRoutePath.PAWN_TRANSACTION_REPORT_DETAIL, component: GadaiReportDetail, },
  { path: AppRoutePath.PROCESS_LOAN_NONCASH, component: ProcessLoanPage },
  { path: AppRoutePath.LIST_PRODUCT, component: ListProducts },
  { path: AppRoutePath.UPLOAD_PRODUCT, component: UploadProduct },
  { path: AppRoutePath.AREA_LIST, component: AreaList },
  { path: AppRoutePath.ADD_AREA_LIST, component: AddArea },
  { path: AppRoutePath.EDIT_AREA_LIST, component: AddArea },

  { path: AppRoutePath.PERMOHONAN_JEMPUT_GADAI, component: JemputGadai },
  { path: AppRoutePath.JEMPUT_GADAI_TERJADWAL, component: GadaiTerjadwal },

  { path: AppRoutePath.PERMOHONAN_PENGEMBALIAN_BARANG, component: PermohonanPengembalian },
  { path: AppRoutePath.PENGEMBALIAN_TERJADWAL, component: PengembalianTerjadwal, },
  { path: AppRoutePath.HISTORY_TERJADWAL, component: HistoryPengembalian },
  { path: AppRoutePath.APPRAISER_LIST, component: AppraiserList },
  { path: AppRoutePath.APPRAISER_LIST_BY_OUTLET, component: OutletAppraiserList },
  { path: AppRoutePath.APPRAISER_ADD_BY_OUTLET, component: AddOutletAppraiser },
  { path: AppRoutePath.APPRAISER_EDIT_BY_OUTLET, component: AddOutletAppraiser },
  { path: AppRoutePath.EXCLUSIVE_LIST, component: ExclusiveList },
  { path: AppRoutePath.EXCLUSIVE_ADD, component: ExclusiveAdd },
  { path: AppRoutePath.COMPANY_SETTING, component: CompanySetting },
  { path: AppRoutePath.COMMISSION_DISBURSEMENT, component: CommissionDisbursement },
  { path: AppRoutePath.MEMBERSHIP_SETTING, component: MembershipSetting },
  { path: AppRoutePath.BANK_LIST, component:BankList },
  { path: AppRoutePath.NOTIFICATION_SETTING, component:NotificationSettingList },
  { path: AppRoutePath.ADD_NOTIFICATION, component:AddNotification },
  { path: AppRoutePath.EDIT_NOTIFICATION, component:AddNotification },
  { path: AppRoutePath.CAMPAIGN_INSTALLMENT_ADD, component:AddCampaignInstallmentRegulerV2 },
  { path: AppRoutePath.CAMPAIGN_INSTALLMENT_ADD_OFFER, component:AddCampaignInstallmentOfferV2 },
  { path: AppRoutePath.REDEEM, component:Redeem },
  { path: AppRoutePath.VOUCHER, component:Voucher },
];

export default AppRouteData;
